import React, { useContext } from 'react'
import { Container, Row, Col, Visible } from 'react-awesome-styled-grid'

import Badge from '../components/Badge'
import Button from '../components/Button'
import { Section, SectionHeading, SectionContent } from '../components/Section'
import Text from '../components/Text'
import Title from '../components/Title'
import Video from '../components/Video'
import { ModalContext } from '../hooks'
import { IconCorn, IconBadge } from './styled'

const Intro = () => {
  const { setModalState } = useContext(ModalContext)

  return (
    <Section
      id="inicio"
      className="texture-light"
      bg="dark"
      paddingTop={150}
      paddingBottom={60}
    >
      <Container className="h-100">
        <Row
          align="center"
          className="h-100"
          justify={{ xs: 'center', md: 'space-between' }}
        >
          <Col sm={10} md={5}>
            <SectionHeading marginBottom={32}>
              <Badge
                label="Videoaulas"
                marginBottom={16}
                data-sal="slide-right"
                data-sal-delay="300"
                data-sal-easing="ease"
                data-sal-duration="800"
              />
              <Title
                appearance="hero"
                color="light"
                level={1}
                afterTitle="por Onildo Rocha"
                data-sal="slide-right"
                data-sal-delay="400"
                data-sal-easing="ease"
                data-sal-duration="800"
              >
                <span className="t-lowercase">A nova cozinha nordestina</span>
              </Title>
              <IconCorn
                name="corn"
                size={130}
                data-sal="slide-up"
                data-sal-delay="400"
                data-sal-easing="ease"
                data-sal-duration="800"
              />
            </SectionHeading>
            <SectionContent marginBottom={32}>
              <Text
                color="light"
                size={22}
                marginBottom={24}
                data-sal="slide-right"
                data-sal-delay="500"
                data-sal-easing="ease"
                data-sal-duration="800"
              >
                <b>
                  Assista o vídeo{' '}
                  <Visible xs sm>
                    abaixo
                  </Visible>{' '}
                  e descubra do que é feita a Nova Cozinha Nordestina.
                </b>{' '}
                Em poucos passos, você vai dar um passeio pela terra — suas
                origens e seu futuro — aí mesmo, na sua casa!
              </Text>
              <Button
                target="_blank"
                href="https://pay.hotmart.com/N37277066I?checkoutMode=0&bid=1593475180852"
                title="Comprar"
                color="primary"
                data-sal="slide-right"
                data-sal-delay="600"
                data-sal-easing="ease"
                data-sal-duration="800"
                solid
              >
                Comprar
              </Button>

              <Text
                marginTop={12}
                size={10}
                appearance="tag"
                color="light"
                className="t-uppercase"
                data-sal="slide-right"
                data-sal-delay="800"
                data-sal-easing="ease"
                data-sal-duration="700"
              >
                Módulo Macaxeira + Módulo Milho
              </Text>
            </SectionContent>
          </Col>
          <Col sm={10} md={6} style={{ position: 'relative' }}>
            <IconBadge
              name="badge"
              size={120}
              data-sal="zoom-in"
              data-sal-delay="900"
              data-sal-easing="ease"
              data-sal-duration="800"
            />
            <Video youtubeId="9Eq9gaSY9Go" poster="/images/video.png" />
          </Col>
        </Row>
      </Container>
    </Section>
  )
}

export default Intro
